import React, { useRef } from "react";
import { Button, Box, Chip, Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import { AdBanner } from "../AdBanner";

/* global gtag */

export function CongratsDialog({
  open,
  onClose,
  startMovie,
  endMovie,
  finalFrameCount,
  frameEmoji,
  hintEmoji,
  hintCount,
  parsedAverage,
  minimumFrameCount,
  isReelHidden,
  onToggleReel,
  route,
  currentStreak,
  countdown,
  dailyGifUrl,
  showInstaPrompt,
  onDismissInstaPrompt,
  onPlayAgain,
  onShareClick,
  onRevealShowcase,
}) {
  const instaPromptRef = useRef(null);

  return (
    <Dialog
      open={open}
      fullScreen
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      container={document.body}
    >
      <DialogTitle sx={{ fontFamily: "'Oswald', sans-serif", fontSize: "24px", textAlign: "center", paddingTop: "20px" }}>
        Reel Complete!
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", paddingBottom: "16px" }}>
        <img
          src={dailyGifUrl}
          alt="Congrats GIF"
          style={{ maxWidth: "100%", height: "180px", objectFit: "cover", marginBottom: "16px", borderRadius: "8px" }}
        />

        <Typography
          variant="body1"
          sx={{ fontFamily: "'Montserrat', sans-serif", fontSize: "16px", marginBottom: "10px", zIndex: 9999, position: "relative" }}
        >
          <strong>{startMovie}</strong> → <strong>{endMovie}</strong>
          <br />
          <span style={{ marginRight: "4px", fontWeight: "bold", fontSize: "20px" }}>{frameEmoji}</span>
          <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "15px" }}>
            {finalFrameCount === 1 ? "Frame" : "Frames"}
          </span>
          <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "20px" }}> |</span>
          <span style={{ marginLeft: "8px", marginRight: "6px", fontSize: "20px" }}>{hintEmoji}</span>
          <span style={{ fontSize: "15px" }}>Hints</span>
        </Typography>

        {parsedAverage !== null && (
          <Typography
            variant="body1"
            style={{ fontSize: "12px", fontFamily: "'Montserrat'", marginTop: "-6px", marginBottom: "12px", fontStyle: "italic" }}
          >
            Today's Average: <span style={{ fontSize: "12px" }}>{parsedAverage}</span>
            <span style={{ fontSize: "16px", fontFamily: "'Montserrat'" }}> ·</span> Fastest: {minimumFrameCount}
            <span style={{ marginLeft: 8 }}>
              <button
                type="button"
                onClick={onRevealShowcase}
                style={{
                  background: "none", border: "none", padding: 0, margin: 0,
                  color: "#FF8C00", textDecoration: "underline",
                  fontFamily: "'Montserrat', sans-serif", fontSize: "12px",
                  fontStyle: "italic", cursor: "pointer",
                }}
              >
                Reveal!
              </button>
            </span>
          </Typography>
        )}

        {!isReelHidden && (
          <Box sx={{ marginBottom: 2 }}>
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "6px", marginBottom: "20px" }}>
              {route.map((entry, index) => (
                <Chip
                  key={index}
                  label={entry.name || entry}
                  size="small"
                  avatar={
                    entry.image ? (
                      <img src={entry.image} alt={entry.name} style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "cover" }} />
                    ) : null
                  }
                  sx={{ fontFamily: "'Montserrat', sans-serif", fontSize: "12px" }}
                />
              ))}
            </div>
          </Box>
        )}

        {showInstaPrompt && (
          <div
            ref={instaPromptRef}
            style={{
              position: "absolute", top: "360px", left: "50%", transform: "translateX(-50%)",
              backgroundColor: "#ffe6e6", border: "1px solid #ccc", borderRadius: "8px",
              padding: "8px 12px", fontFamily: "'Montserrat'", fontSize: "12px",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)", zIndex: 9999,
              width: "240px", textAlign: "center",
            }}
          >
            <div style={{ marginBottom: "4px" }}>
              <strong>Share your Reely on Reddit.</strong>
              <br /><br />
              <a href="https://www.reddit.com/r/playreely/" target="_blank" rel="noopener noreferrer" style={{ color: "#3f51b5", textDecoration: "underline" }}>
                r/playreely
              </a>
            </div>
            <div
              style={{ position: "absolute", top: "4px", right: "4px", cursor: "pointer", fontWeight: "bold", fontSize: "10px", color: "#666" }}
              onClick={onDismissInstaPrompt}
            >
              ✖
            </div>
          </div>
        )}

        <Button
          variant="outlined"
          size="small"
          onClick={onToggleReel}
          sx={{
            borderRadius: "12px", padding: "2px 8px", minHeight: "28px", fontSize: "10px",
            fontFamily: "'Montserrat', sans-serif", textTransform: "none",
            backgroundColor: "transparent", borderColor: "#ccc", boxShadow: "none",
            height: "32px", marginBottom: 2,
          }}
        >
          {isReelHidden ? "SHOW REEL" : "HIDE REEL"}
        </Button>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, flexWrap: "wrap", mt: 1 }}>
          <Button
            variant="contained"
            onClick={() => {
              if (typeof gtag === "function") {
                gtag("event", "play_again_click", { event_category: "Engagement", event_label: "Clicked Play Again" });
              }
              onPlayAgain();
            }}
            sx={{ fontFamily: "'Montserrat'", marginTop: "-6px" }}
          >
            Play Again
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              onShareClick();
              if (typeof gtag === "function") {
                gtag("event", "share_button_click", { event_category: "Engagement", event_label: "Opened Share Your Reel dialog" });
              }
            }}
            sx={{ fontFamily: "'Montserrat'", marginTop: "-6px" }}
          >
            Share Your Reel
          </Button>
        </Box>

        {currentStreak !== null && (
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "12px", marginTop: "16px" }}>
            <Typography variant="body2" sx={{ fontFamily: "'Montserrat', sans-serif", fontSize: "12px", color: "#333" }}>
              🔥 <strong>{currentStreak}-day streak</strong>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "12px", fontFamily: "Montserrat", color: "#333" }}>
              ⏳ Next Reely:{" "}
              <span style={{ display: "inline-block", fontFamily: "'Montserrat', sans-serif", fontSize: "12px", width: "85px", textAlign: "left" }}>
                {countdown.hours}h {countdown.minutes}m {countdown.seconds}s
              </span>
            </Typography>
          </Box>
        )}

        <Typography
          variant="body2"
          sx={{ fontFamily: "'Montserrat'", fontSize: "12px", color: "#666", marginTop: "8px", marginBottom: "12px", textAlign: "center", lineHeight: 1.5 }}
        >
          <a href="https://www.reddit.com/r/playreely" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", textDecoration: "none", marginLeft: "6px", marginRight: "4px" }}>
            <img src="/reddit_logo.png" alt="Reddit" style={{ width: "18px", height: "18px", verticalAlign: "middle" }} />
          </a>
          <a href="https://instagram.com/playreely" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", textDecoration: "none", marginLeft: "4px" }}>
            <img src="/instagram_icon.png" alt="Instagram" style={{ width: "18px", height: "18px", verticalAlign: "middle" }} />
          </a>
          <br />
          <AdBanner />
          Reely is in beta —{" "}
          <a href="https://forms.gle/2S2pVvDajVmX7KWJ7" target="_blank" rel="noopener noreferrer" style={{ color: "#3f51b5", textDecoration: "underline" }}>
            share feedback
          </a>
          !
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
